import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppStartState } from './app-start.reducer';

const appStartFeatureSelector = createFeatureSelector<AppStartState>('appStart');

export const getAppStartState = createSelector(appStartFeatureSelector, (state) => {
   return state.startupStep;
});

export const getAppStartCallState = createSelector(appStartFeatureSelector, (state) => {
   return state.callState;
});
